<template>
  <div class="focused-panel">
    <div class="d-flex lpd-skip-toolbar">
      <!-- <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Create LPD Skip" :pressed.sync="addEnabled" variant="primary">
        <icon scale=".6" name="plus"/>
      </b-btn> -->

      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Select LPD Skip" :pressed.sync="selectEnabled" variant="primary">
        <icon scale=".6" name="hand-pointer"/>
      </b-btn>

      <b-btn size="sm" class="dtron-toolbar-button tool1"  :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
        <icon scale=".6" name="undo"/>
      </b-btn>
      <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
        Undo
      </b-tooltip>


      <b-btn size="sm" class="dtron-toolbar-button tool1"  v-b-tooltip.hover.auto title="Edit LPD Skip geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled"
             variant="primary">
        <icon scale=".6" name="arrows-alt"/>
      </b-btn>

      <!-- <b-btn size="sm" class="dtron-toolbar-button tool1"  @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete LPD Skip" :disabled="!wellFeatureSelected"
             variant="primary">
        <icon scale=".6" name="times"/>
      </b-btn> -->

    </div>
  </div>
</template>

<script>

  import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

  export default {
    name: 'lpd-skip-editor',
    components: {},
    mixins: [FeatureEditorMixin],
    data () {
      return {
        geomType: 'Point',
        wellLayerName: 'v4:lpd_skip',
        wellAttrs: {
          ident: '',
          comment: '',
          asset_tag: '',
          station_data_id: null,
          type: 'skip'
        },
        schema: 'lpd',
        hoverLock: false,
        lockable: true,
        identState: null,
        initialIdent: null,
        lpdLibOptions: [],
      }
    },
    methods: {
      _addFeature (feature) {
        feature.set('comment', 'custom')
        this.newFeatures.push(feature)
        this.propagateFeatureChange('add', [feature])
        this.save()
      },
      close(evt) {
        this.wellFeature = null
        this.showForm = false
        this.onCancel()
      },
    },
    watch: {
      wellAttrs: {
        handler(val) {
          if (!this.initialIdent) {
            this.initialIdent = val.ident
          }
          else if (this.initialIdent !== val.ident) {
            let me = this
            this.validateIdent(val.ident)
          } else {
            this.identState = null
          }
        },
        deep: true
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/LpdSkipEditor.vue